import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=660bd56c&scoped=true&"
import script from "./colorPicker.vue?vue&type=script&lang=js&"
export * from "./colorPicker.vue?vue&type=script&lang=js&"
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=660bd56c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660bd56c",
  null
  
)

component.options.__file = "colorPicker.vue"
export default component.exports